import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheet, BottomSheetProps } from '@shared/ui/molecules';
import ModalContent from './ModalContent';
type RegionsWithRestrictionsIntructionModalMobileProps = BottomSheetProps;
const RegionsWithRestrictionsIntructionModalMobile: FC<RegionsWithRestrictionsIntructionModalMobileProps> = ({
  open,
  onClose,
  ...rest
}) => <BottomSheet open={open} onClose={onClose} {...rest}>
    <ContentWrapper>
      <ModalContent onClose={onClose} />
    </ContentWrapper>
  </BottomSheet>;
export default RegionsWithRestrictionsIntructionModalMobile;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c14k2zje",
  propsAsIs: false,
  vars: {
    "c14k2zje-0": [_exp()]
  }
}));

require("./RegionsWithRestrictionsIntructionModalMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./RegionsWithRestrictionsIntructionModalMobile.tsx");